import { render, staticRenderFns } from "./dianpu_new.vue?vue&type=template&id=1b34fa3a&scoped=true&"
import script from "./dianpu_new.vue?vue&type=script&lang=js&"
export * from "./dianpu_new.vue?vue&type=script&lang=js&"
import style0 from "./dianpu_new.vue?vue&type=style&index=0&id=1b34fa3a&prod&lang=less&"
import style1 from "./dianpu_new.vue?vue&type=style&index=1&id=1b34fa3a&prod&lang=css&"
import style2 from "./dianpu_new.vue?vue&type=style&index=2&id=1b34fa3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b34fa3a",
  null
  
)

export default component.exports